// extracted by mini-css-extract-plugin
export default {"center":"Header_center__K0kzQ","center-run-time":"Header_center-run-time__ZNjpa","status":"Header_status__urebV","status-ups":"Header_status-ups__6yoMb"};